<template>
  <FormulateInput
    v-bind="field"
    validation-behavior="live"
    :disabled="disabled"
    :value="computedValue"
    :fullObject="fullObject"
    @update:fullObject="$emit('update:fullObject', $event)"
    @input="handleInput"
  />
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      default: () => {},
    },
    modalValue: {
      type: Number,
      default: null,
    },
    fullObject: {
      type: Object,
      default: () => {},
    },
    vehicleFullObj: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return nul
      if (this.modelValue === '' || this.modelValue === false || this.modelValue === undefined)
        return null

      return Number(this.modelValue)
    },
  },
  watch: {
    vehicleFullObj(newValue) {
      if (newValue?.id === undefined) return
      if (newValue?.driver == null) return
      if (newValue?.driver?.is_available == false) return

      this.$emit('input', newValue.driver.id)
      this.$emit('update:fullObject', newValue.driver)
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      this.$emit('input', Number(newValue))
    },
  },
}
</script>
